export const MIN_ZOOM = 0.25
export const MAX_ZOOM = 4
export const ZOOM_STEP = 0.1

export function clampZoom(zoom: number): number {
  return Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, zoom))
}

export function zoomIn(current: number): number {
  return clampZoom(current + ZOOM_STEP)
}

export function zoomOut(current: number): number {
  return clampZoom(current - ZOOM_STEP)
}

export function fitZoomToViewport(
  templateDims: { widthMm: number; heightMm: number },
  viewport: { widthPx: number; heightPx: number },
  pxPerMmAt1x = 4
): number {
  if (templateDims.widthMm <= 0 || templateDims.heightMm <= 0) return 1
  const widthAt1x = templateDims.widthMm * pxPerMmAt1x
  const heightAt1x = templateDims.heightMm * pxPerMmAt1x
  const scaleX = viewport.widthPx / widthAt1x
  const scaleY = viewport.heightPx / heightAt1x
  return clampZoom(Math.min(scaleX, scaleY) * 0.9)
}

export function snapToGrid(valueMm: number, gridMm = 1): number {
  return Math.round(valueMm / gridMm) * gridMm
}
